export type FileType = "image" | "docs" | "video" | "other";

export function determineFileTypeFromExtension(location: string): FileType {
  const extension = location?.split(".")?.pop()?.toLowerCase();
  if (extension) {
    switch (extension) {
      case "pdf":
      case "doc":
      case "docx":
      case "xlsx":
      case "xls":
      case "pptx":
      case "ppt":
        return "docs";
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
        return "image";
      case "mp4":
      case "mov":
      case "avi":
      case "wmv":
      case "flv":
      case "webm":
        return "video";
      default:
        return "other";
    }
  }
  return "other";
}

export function determineFileTypeFromMimeType(mimeType: string): FileType {
  if (mimeType) {
    switch (mimeType.toLowerCase()) {
      //TODO: Add more cases here
      case "application/pdf":
        return "docs";
      default:
        return "other";
    }
  }
  return "other";
}
